import React from 'react';
import KycGenericVerification from './KycGenericVerification';

export default function KycCourtCaseCheck() {
  const formatDobInput = (value) => {
    const digits = String(value || '').replaceAll(/\D/g, '').slice(0, 8);
    if (digits.length === 0) return '';
    if (digits.length === 1) return digits;
    if (digits.length === 2) return `${digits}-`;
    if (digits.length === 3) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    if (digits.length === 4) return `${digits.slice(0, 2)}-${digits.slice(2)}-`;
    return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
  };

  const normalizeDob = (value) => {
    const input = String(value || '').trim();
    if (!input) return '';

    if (/^\d{8}$/.test(input)) {
      return `${input.slice(0, 2)}-${input.slice(2, 4)}-${input.slice(4)}`;
    }

    if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(input)) {
      return input.replaceAll('/', '-');
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [year, month, day] = input.split('-');
      return `${day}-${month}-${year}`;
    }

    return input;
  };

  const isValidDob = (value) => {
    const input = String(value || '').trim();
    return /^\d{8}$/.test(input)
      || /^\d{2}[-/]\d{2}[-/]\d{4}$/.test(input)
      || /^\d{4}-\d{2}-\d{2}$/.test(input);
  };

  return (
    <KycGenericVerification
      title="Court Case Check"
      description="Check for court case records before running credit checks."
      kycType="court-case-check"
      costField="courtCaseCheckCost"
      submitLabel="Submit Court Case Check"
      inputs={[
        {
          name: 'fullName',
          label: 'Full Name',
          placeholder: 'Full name',
          maxLength: 150,
          validator: (value) => String(value || '').trim().length >= 3,
          errorMessage: 'Full name is required'
        },
        {
          name: 'fatherName',
          label: 'Father Name',
          placeholder: 'Father name',
          maxLength: 150,
          validator: (value) => String(value || '').trim().length >= 3,
          errorMessage: 'Father name is required'
        },
        {
          name: 'dob',
          label: 'Date of Birth',
          type: 'text',
          placeholder: 'DD-MM-YYYY',
          maxLength: 10,
          formatter: formatDobInput,
          transform: normalizeDob,
          validator: isValidDob,
          errorMessage: 'Use DOB as DDMMYYYY, DD-MM-YYYY, DD/MM/YYYY or YYYY-MM-DD'
        },
        {
          name: 'address',
          label: 'Address',
          placeholder: 'Full address',
          maxLength: 300,
          validator: (value) => String(value || '').trim().length >= 5,
          errorMessage: 'Address is required'
        }
      ]}
      referenceFormatter={(item) => item.fullName || 'N/A'}
    />
  );
}

